import { c } from "react/compiler-runtime";
import { useDataProvider } from "@effektify/data-provider";
import { mapValueWithTrendProps } from "../../utils/cardProps.js";
import useReportTranslations from "../useReportTranslations.js";
const useValueWithTrendProps = (config, data) => {
  const $ = c(5);
  const {
    translate
  } = useReportTranslations();
  const {
    noComparison
  } = useDataProvider();
  let t0;
  if ($[0] !== config || $[1] !== data || $[2] !== noComparison || $[3] !== translate) {
    t0 = mapValueWithTrendProps(config, data ?? {}, {
      translate,
      noComparison: !!noComparison
    });
    $[0] = config;
    $[1] = data;
    $[2] = noComparison;
    $[3] = translate;
    $[4] = t0;
  } else {
    t0 = $[4];
  }
  return t0;
};
export { useValueWithTrendProps as default };